import { Directive, Input, inject } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Directive()
export class FormBaseComponent {
  @Input() labelT = '';
  @Input({ required: true }) controlKey: string;
  @Input() validationRules: any = {};

  parentContainer: ControlContainer = inject(ControlContainer);
  translate = inject(TranslateService);

  errorMap: any = {
    required: 'shared.error.required',
    maxlength: 'shared.error.max-length',
    pattern: 'shared.error.pattern',
  };

  get labelInternal() {
    return this.translate.instant(this.labelT);
  }

  get parentFormGroup() {
    return this.parentContainer.control as FormGroup;
  }

  get control() {
    return this.parentFormGroup.get(this.controlKey);
  }

  get errorsArray() {
    return Object.entries({ ...this.errorMap, ...this.validationRules! })
      .map(([key, messageT]) => ({
        key,
        messageT: typeof messageT === 'string' ? messageT : null,
        messageFn: typeof messageT === 'function' ? messageT : null,
      }))
      .filter(({ key }) => this.control?.hasError(key));
  }

  trackBy(err: any) {
    return err.key;
  }

  displayErrorMessage(err: any) {
    if (err.key === 'required' && this.labelT) {
      return this.translate.instant('shared.error.requiredF').replace('{field}', this.labelInternal);
    }

    if (err.key === 'pattern' && this.labelT) {
      return this.translate.instant('shared.error.patternF').replace('{field}', this.labelInternal);
    }

    if (err.messageT) {
      return this.translate.instant(err.messageT);
    }

    if (err.messageFn) {
      return err.messageFn(this.translate);
    }

    return `${err.key} is not valid`;
  }
}
